import { render, staticRenderFns } from "./EstablishmentInactiveAlert.vue?vue&type=template&id=38542834"
import script from "./EstablishmentInactiveAlert.vue?vue&type=script&lang=js"
export * from "./EstablishmentInactiveAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports